import { render } from "./TestSampleTypeTag.vue?vue&type=template&id=1e84c613&scoped=true"
import script from "./TestSampleTypeTag.vue?vue&type=script&lang=js"
export * from "./TestSampleTypeTag.vue?vue&type=script&lang=js"

import "./TestSampleTypeTag.vue?vue&type=style&index=0&id=1e84c613&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e84c613"]])

export default __exports__